import React, { useCallback, useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import Table from "./Table";
import AddFAQ from "./AddFAQ";
import EditFAQ from "./EditFAQ";
import Pagination from "../Pagination";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  FormControl,
  Autocomplete,
  Select,
  TextField,
  MenuItem,
} from "@mui/material";

function FAQ() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState([]);
  const [faqCategory, setFaqCategory] = useState([]);
  const [faqCategories, setFaqCategories] = useState([]);
  const [status, setStatus] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const { logoutUser, user } = useContext(AuthContext);
  const manager = user?.permission?.find((e) => e.manager === "faqs") ?? {};
  const [editShowModal, setEditShowModal] = useState(false);
  const [FAQs, setFAQS] = useState([]);
  const [page, setPage] = useState(1);
  const [item, setItem] = useState("");
  const [sort, setSort] = useState({
    sort_key: "createdAt",
    sort_type: "desc",
  });
  const navigate = useNavigate();
  const getAllFAQ = async (payload) => {
    try {
      if (payload?.deletePage) {
        payload = {
          page,
          status: status !== "all" ? status : undefined,
          projectId: projectId ? projectId : undefined,
          search: search ? search : undefined,
          faqCategory: faqCategory ? faqCategory : undefined,
        };
        if (!(FAQs?.length > 1)) {
          setPage(page - 1);
          setPaginationObj({ ...paginationObj, page: page - 1 });
        }
      } else {
        payload = {
          page,
          status: status !== "all" ? status : undefined,
          sort_key: sort.sort_key,
          sort_type: sort.sort_type,
          projectId: projectId ? projectId : undefined,
          search: search ? search : undefined,
          faqCategory: faqCategory ? faqCategory : undefined,
        };
      }

      const path = apiPath.getFAQs;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setFAQS(response?.docs);
        setPaginationObj({
          ...paginationObj,
          // page: response.page,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.error("error in get all FAQs list==>>>>", error.message);
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handelEdit = (item) => {
    setItem(item);
    setEditShowModal(true);
  };
  useEffect(() => {
    getAllFAQ();
  }, [page, sort, projectId, status, faqCategory]);

  const getProjects = useCallback(async () => {
    try {
      const payload = {};
      const path = apiPath.projectPath + "/all-projects";
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      setProjects(records);
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  }, []);

  const getFaqCategories = useCallback(async () => {
    try {
      const path = apiPath.getFAQsCategories;
      const result = await apiGet(path);
      const records = result?.data?.results;
      setFaqCategories(records);
    } catch (error) {
      console.error(
        "error in get all faq categories list==>>>>",
        error.message,
      );
    }
  }, []);

  useEffect(() => {
    getProjects();
    getFaqCategories();
  }, [getProjects, getFaqCategories]);

  return (
    <div>
      <div className="bg-white">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9]">
            <div className="flex justify-between items-center gap-2 px-2 mt-2">
              <div className="flex items-center gap-2">
                <TextField
                  id="outlined-basic"
                  label="Search..."
                  variant="outlined"
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setPage(1);
                      getAllFAQ();
                    }
                  }}
                />
                <FormControl className="w-[200px]">
                  <Autocomplete
                    multiple
                    options={projects}
                    getOptionLabel={(option) => option.title || ""}
                    value={projects.filter((project) =>
                      projectId.includes(project._id),
                    )}
                    onChange={(_, newValue) => {
                      setPage(1);
                      setProjectId(newValue.map((project) => project._id));
                    }}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("SELECT_PROJECT")}
                        placeholder={t("SELECT_PROJECT")}
                      />
                    )}
                  />
                </FormControl>
                <FormControl className="w-[200px]">
                  <Select
                    value={status}
                    defaultValue="all"
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <MenuItem value="all">{t("O_ALL")}</MenuItem>
                    <MenuItem value="active">{t("O_ACTIVE")}</MenuItem>
                    <MenuItem value="inactive">{t("O_INACTIVE")}</MenuItem>
                  </Select>
                </FormControl>
                <FormControl className="w-[200px]">
                  <Autocomplete
                    multiple
                    options={faqCategories}
                    getOptionLabel={(option) => option.title || ""}
                    value={faqCategories.filter((category) =>
                      faqCategory.includes(category._id),
                    )}
                    onChange={(_, newValue) => {
                      setPage(1);
                      setFaqCategory(newValue.map((category) => category._id));
                    }}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("SELECT_FAQ_CATEGORY")}
                        placeholder={t("SELECT_FAQ_CATEGORY")}
                      />
                    )}
                  />
                </FormControl>
              </div>
              <div className="flex mt-2">
                {(manager?.add || user?.role === "admin") && (
                  <button
                    // type='submit'
                    title={t("FAQS_ADD_FAQS")}
                    className="bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap"
                    onClick={() => setShowModal(true)}
                  >
                    + {t("FAQS_ADD_FAQS")}
                  </button>
                )}
                {(manager?.import || user?.role === "admin") && (
                  <button
                    // type='submit'
                    title={t("FAQS_IMPORT_FAQS")}
                    className="bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap"
                    onClick={() => navigate("/static/faqs/import-faqs")}
                  >
                    + {t("FAQS_IMPORT_FAQS")}
                  </button>
                )}
              </div>
            </div>
            <Table
              FAQs={FAQs}
              getAllFAQ={getAllFAQ}
              handelEdit={handelEdit}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
      <>
        {showModal && (
          <AddFAQ setShowModal={setShowModal} getAllFAQ={getAllFAQ} />
        )}
        {editShowModal && (
          <EditFAQ
            setEditShowModal={setEditShowModal}
            getAllFAQ={getAllFAQ}
            item={item}
          />
        )}
      </>
    </div>
  );
}

export default FAQ;
